import React, { useState, useEffect, Fragment } from 'react';
import {
    Row,
    Card,
    CardBody,
    CardImg,
    Button,
    Input,
    Label,
    ModalHeader,
    Modal,
    ModalBody, Nav, TabContent, TabPane, NavItem,
} from 'reactstrap';
import { NavLink } from 'react-router-dom';
import classnames from 'classnames';
import { Colxx, Separator } from '../../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
import '../../style/style.css';
import { API_Ingetration, gAPI_QuestionSets } from '../../../../../../constants/APIs';
import ImageGallery from '../../../propinfo/gallery/index';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import 'rc-switch/assets/index.css';
const quillModules = {
    toolbar: [
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [
            { list: 'ordered' },
            { list: 'bullet' },
            { indent: '-1' },
            { indent: '+1' },
        ],
        ['link', 'image'],
        ['clean'],
    ]
};

const quillFormats = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'indent',
    'link',
    'image',
];
export default function HelpCenterChatBot({ botSettings, saveIntegration, locale }) {
    const [checkedPrimarySmall, setCheckedPrimarySmall] = useState(botSettings.chatBot !== null &&
        !botSettings.chatBot.botDisabled
    );
    const [checkedProperty, setCheckedProperty] = useState(botSettings.chatBot !== null &&
        !botSettings.chatBot.propertyDisabled
    );
    const [checkedPropertyBot, setCheckedPropertyBot] = useState(botSettings.chatBot !== null &&
        botSettings.chatBot.propertyChatBot !== null &&
        !botSettings.chatBot.propertyChatBot.propertyDisabled
    );
    const [activeTab, setActiveTab] = useState('chatbot');
    const [inputFields, setInputFields] = useState([{ text: '', value: '', locale: locale }]);
    const [integrationList, setIntegrationList] = useState([]);
    const [chatBotDetails, setChatBotDetails] = useState({
        title: "",
        subTitle: "",
        contactInformation: "",
        locale: locale
    });
    const [propertyDetails, setPropertyDetails] = useState({
        title: "",
        subTitle: "",
        contactInformation: "",
        locale: locale
    });
    const [botProperty, setBotProperty] = useState({
        disabled: false,
        propertyDetails: {
            title: "",
            subTitle: "",
            contactInformation: "",
            locale: locale
        }
    });
    const [galleryVisible, setGalleryVisible] = useState(false);
    const [botInputData, setBotInputData] = useState({
        botDisabled: false,
        botIntegrationId: "",
        botIntegrationIcon: "",
        propertyDisabled: false,
        avatarImage: ""
    });
    const [recommenderData, setRecommender] = useState([]);
    useEffect(() => {
        let body = {
            channels: ['WebsiteDirectLine']
        };
        AxiosAPI({
            method: 'post',
            url: `${API_Ingetration}?group_id=${getGroupID()}`,
            data: body
        }).then((res) => {
            const webIntegrationData = res.data.filter(
                (k) => k.channel === 'WebsiteDirectLine' && k.disabled === false
            );
            setIntegrationList(webIntegrationData);
        });
        if (botSettings !== undefined && botSettings.chatBot !== null) {
            if (botSettings.chatBot.chatBotDetails !== null) {
                var chatbot = botSettings.chatBot.chatBotDetails.filter(i => i.locale === locale);
                if (chatbot.length > 0) {
                    setChatBotDetails({
                        title: chatbot[0].title,
                        subTitle: chatbot[0].subTitle,
                        contactInformation: chatbot[0].contactInformation,
                        locale: locale
                    })
                } else {
                    var chatbotEn = botSettings.chatBot.chatBotDetails.filter(i => i.locale === "en");
                    if (chatbotEn.length > 0) {
                        setChatBotDetails({
                            title: chatbotEn[0].title,
                            subTitle: chatbotEn[0].subTitle,
                            contactInformation: chatbotEn[0].contactInformation,
                            locale: locale
                        });
                    }
                    else {
                        setChatBotDetails({
                            title: "",
                            subTitle: "",
                            contactInformation: "",
                            locale: locale
                        });
                    }
                }
            }
            if (botSettings.chatBot.propertyDetails !== null) {
                var propertydetail = botSettings.chatBot.propertyDetails.filter(i => i.locale === locale);
                if (propertydetail.length > 0) {
                    setPropertyDetails({
                        ...propertyDetails,
                        title: propertydetail[0].title,
                        subTitle: propertydetail[0].subTitle,
                        contactInformation: propertydetail[0].contactInformation,
                        locale: locale
                    })
                } else {
                    var propertyEn = botSettings.chatBot.propertyDetails.filter(i => i.locale === "en");
                    if (propertyEn.length > 0) {
                        setPropertyDetails({
                            title: propertyEn[0].title,
                            subTitle: propertyEn[0].subTitle,
                            contactInformation: propertyEn[0].contactInformation,
                            locale: locale
                        });
                    }
                    else {
                        setPropertyDetails({
                            title: "",
                            subTitle: "",
                            contactInformation: "",
                            locale: locale
                        });
                    }
                }
            }
            if (botSettings.chatBot.propertyChatBot !== null && botSettings.chatBot.propertyChatBot.propertyDetails !== null) {
                var propertyDetailBody = null;
                var propertydetail = botSettings.chatBot.propertyChatBot.propertyDetails.filter(i => i.locale === locale);
                if (propertydetail.length > 0) {
                    propertyDetailBody = {
                        title: propertydetail[0].title,
                        subTitle: propertydetail[0].subTitle,
                        contactInformation: propertydetail[0].contactInformation,
                        locale: locale
                    }
                } else {
                    var propertyEn = botSettings.chatBot.propertyChatBot.propertyDetails.filter(i => i.locale === "en");
                    if (propertyEn.length > 0) {
                        propertyDetailBody = {
                            title: propertyEn[0].title,
                            subTitle: propertyEn[0].subTitle,
                            contactInformation: propertyEn[0].contactInformation,
                            locale: locale
                        };
                    }
                    else {
                        propertyDetailBody = {
                            title: "",
                            subTitle: "",
                            contactInformation: "",
                            locale: locale
                        };
                    }
                }
                setBotProperty({
                    ...botSettings.chatBot.propertyChatBot,
                    disabled: botSettings.chatBot.propertyChatBot.disabled,
                    propertyDetails: propertyDetailBody
                });
            }
            if (botSettings.chatBot.propertyButtons !== null) {
                var button = botSettings.chatBot.propertyButtons.filter(i => i.locale === locale);
                if (button.length > 0) {
                    setInputFields(button);
                }
                else {
                    var buttonEn = botSettings.chatBot.propertyButtons.filter(i => i.locale === "en");
                    if (buttonEn.length > 0) {
                        var dataEn = [];
                        buttonEn.map(i => {
                            dataEn.push({ text: i.text, option: i.option, value: i.value, locale: locale });
                        })
                        setInputFields(dataEn);
                    }
                }
            }
            setBotInputData({
                ...botSettings.chatBot,
                botDisabled: botSettings.chatBot.botDisabled,
                botIntegrationIcon: botSettings.chatBot.botIntegrationIcon,
                botIntegrationId: botSettings.chatBot.botIntegrationId === null ? "" : botSettings.chatBot.botIntegrationId,
                propertyDisabled: botSettings.chatBot.propertyDisabled,
                avatarImage: botSettings.chatBot.avatarImage,
            });
        }
        loadRecommender();
    }, [botSettings]);

    const loadRecommender = async () => {
        return await AxiosAPI({
            methed: 'get',
            url: `${gAPI_QuestionSets}/?propertyId=-1&groupId=${getGroupID()}&lang=${locale}`,
        })
            .then(res => {
                setRecommender(res.data.sets);
            })
            .catch(err => {
                console.log(err);
            });
    };

    const handleSave = (e) => {
        let setting = botSettings;
        var existingDetail = setting.chatBot.chatBotDetails.filter(i => i.locale !== locale);
        var assitantdata = [...existingDetail, chatBotDetails];
        var existingproDetail = setting.chatBot.propertyDetails.filter(i => i.locale !== locale);
        var propertydata = [...existingproDetail, propertyDetails];

        var existingprobotDetail = setting.chatBot.propertyChatBot === null ? [] : setting.chatBot.propertyChatBot.propertyDetails === null ? [] : setting.chatBot.propertyChatBot.propertyDetails.filter(i => i.locale !== locale);
        var propertybotdata = [...existingprobotDetail, botProperty.propertyDetails];
        var propertyBotdata = { ...botProperty, propertyDetails: propertybotdata };
        var existButton = setting.chatBot.propertyButtons.filter(i => i.locale !== locale);
        if (inputFields.length > 0) {
            inputFields.map(elem => {
                existButton.push(elem);
            })
        }
        var chatbot = { ...botInputData, chatBotDetails: assitantdata, propertyDetails: propertydata, propertyButtons: existButton, propertyChatBot: propertyBotdata };
        setting.chatBot = chatbot;
        console.log(setting);
        saveIntegration({
            botSetting: setting
        });
    };
    const handleTextChange = (e) => {
        setChatBotDetails({ ...chatBotDetails, [e.target.name]: e.target.value });
    }
    const handleChange = (e) => {
        var integration = integrationList.filter(i => i.id === e.target.value).map(k => k.botSettings !== null && k.botSettings.urls && k.botSettings.urls.icon);
        const iconUrl = integration.length > 0 ? integration[0] : "";
        setBotInputData({ ...botInputData, botIntegrationId: e.target.value, botIntegrationIcon: iconUrl });
    };
    const handleChangeContact = (source, data) => {
        if (source === 'user') {
            setChatBotDetails({ ...chatBotDetails, contactInformation: data });
        }
    };
    const toggleMenu = (tab) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    };
    const handleSwitchChange = (value) => {
        setCheckedPrimarySmall(value);
        setBotInputData({
            ...botInputData,
            botDisabled: !value
        });
    };
    const handleSwitchPropertyChange = (value) => {
        setCheckedProperty(value);
        setBotInputData({
            ...botInputData,
            propertyDisabled: !value
        });
    };
    const handleSwitchPropertyBotChange = (value) => {
        setCheckedPropertyBot(value);
        setBotProperty({
            ...botProperty,
            disabled: !value
        });
    };
    const togglegallery = () => {
        setGalleryVisible(!galleryVisible);
    };
    const selectedImage = (image) => {
        if (image !== undefined) {
            setBotInputData({ ...botInputData, avatarImage: image.src });
        }
    };
    const handleChangeWelcomeMessage = (source, data) => {
        // console.log(data, propertyDetails, source);
        if (source === 'user') {
            setPropertyDetails({
                ...propertyDetails,
                contactInformation: data
            });
        }
    };
    const handleChangeProperty = (e) => {
        setPropertyDetails({
            ...propertyDetails,
            [e.target.name]: e.target.value
        });
    };
    const handleChangePropertyBot = (e) => {
        var body = { ...botProperty.propertyDetails, [e.target.name]: e.target.value }
        setBotProperty({
            ...botProperty,
            propertyDetails: body
        });
    };
    const handleAddFields = () => {
        const values = [...inputFields];
        values.push({
            text: '',
            option: '',
            value: '',
            locale: locale
        });
        setInputFields(values);
    };
    const handleRemoveFields = index => {
        const values = [...inputFields];
        values.splice(index, 1);
        setInputFields(values);
    };
    const handleInputChange = (index, event) => {
        const values = [...inputFields];
        if (event.target.name === 'text') {
            values[index].text = event.target.value;
        }
        else if (event.target.name === 'value') {
            values[index].value = event.target.value;
        }
        else if (event.target.name === 'option') {
            values[index].option = event.target.value;
            values[index].value = "";
        }

        setInputFields(values);
    };
    const ImageGalleryButton = () => {
        return (
            <Row>
                <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
                    <Row>
                        <Colxx xs="12" sm="3" className="mb-1">
                            <Modal
                                isOpen={galleryVisible}
                                toggle={togglegallery}
                                style={{ maxWidth: '1000px' }}
                            >
                                <ModalHeader toggle={togglegallery}>Select Avatar</ModalHeader>
                                <ModalBody>
                                    <ImageGallery
                                        selectedImage={selectedImage}
                                        togglegallery={togglegallery}
                                        hideUserUploads={false}
                                        searchText={'avatar'}
                                    />
                                </ModalBody>
                            </Modal>
                        </Colxx>
                    </Row>
                </Colxx>
            </Row>
        );
    };
    //console.log(propertyDetails, botInputData, chatBotDetails);
    return (
        <Fragment>
            <Card className="mb-4">
                <CardBody>
                    <h6 className="text-center">Add Chatbot or Contact Information </h6>
                    <Separator className="mb-3" />
                    <Nav tabs className="separator-tabs ml-0 mr-0">
                        <NavItem className="w-30 text-center">
                            <NavLink
                                style={{ marginRight: "0px" }}
                                to="#"
                                location={{}}
                                className={classnames({
                                    active: activeTab === 'chatbot',
                                    'nav-link': true,
                                })}
                                onClick={() => toggleMenu('chatbot')}
                            >
                                Group Chatbot
                            </NavLink>
                        </NavItem>
                        <NavItem className="w-30 text-center">
                            <NavLink
                                style={{ marginRight: "0px" }}
                                to="#"
                                location={{}}
                                className={classnames({
                                    active: activeTab === 'propertybot',
                                    'nav-link': true,
                                })}
                                onClick={() => setActiveTab('propertybot')}
                            >
                                Property Chatbot
                            </NavLink>
                        </NavItem>
                        <NavItem className="w-30 text-center">
                            <NavLink
                                style={{ marginRight: "0px" }}
                                to="#"
                                location={{}}
                                className={classnames({
                                    active: activeTab === 'property',
                                    'nav-link': true,
                                })}
                                onClick={() => setActiveTab('property')}
                            >
                                Property
                            </NavLink>
                        </NavItem>
                    </Nav>
                    <TabContent activeTab={activeTab}>
                        <TabPane tabId="chatbot">
                            <div className="pt-2 pr-4 pl-4 pb-2">
                                <Row>
                                    <Colxx md={12} className="mt-2">
                                        <div className="d-flex w-100">
                                            <Label>Enable</Label>
                                            <Switch
                                                className="agentswitch custom-switch-primary custom-switch-small ml-2"
                                                checked={checkedPrimarySmall}
                                                onChange={(primary) => handleSwitchChange(primary)}
                                            />
                                        </div>
                                    </Colxx>
                                    <Colxx md={12} className="mt-2">
                                        <Label>Title</Label>
                                        <div className="mb-2">
                                            <Input
                                                type="text"
                                                name="title"
                                                placeholder="Title"
                                                value={chatBotDetails.title}
                                                onChange={(e) => handleTextChange(e)}
                                            ></Input>
                                        </div>
                                    </Colxx>
                                    <Colxx md={12} className="mt-2">
                                        <Label>Sub Title</Label>
                                        <div className="mb-2">
                                            <Input
                                                type="text"
                                                name="subTitle"
                                                placeholder="Sub Title"
                                                value={chatBotDetails.subTitle}
                                                onChange={(e) => handleTextChange(e)}
                                            ></Input>
                                        </div>
                                    </Colxx>
                                    <Colxx md={12} className="mt-2">
                                        <Label>Select Chatbot to Integrate</Label>
                                        <div className="mb-2">
                                            <Input
                                                type="select"
                                                className="dropdown-menu dropdowntimezone"
                                                name="botIntegtrationId"
                                                value={botInputData.botIntegrationId}
                                                onChange={(e) => handleChange(e)}
                                            >
                                                <option value={""}>Select Integration</option>
                                                {integrationList.map((item, i) => (
                                                    <option value={item.id} key={i}>
                                                        {item.name === null || item.name === "" ? item.botSettings.name : item.name + " - " + item.botSettings.name}
                                                    </option>
                                                ))}

                                            </Input>
                                        </div>
                                    </Colxx>
                                    {botInputData.botDisabled === true &&
                                        <Colxx md={12} className="mt-3">
                                            <Label>Contact Information</Label>
                                            <ReactQuill
                                                theme="snow"
                                                value={chatBotDetails.contactInformation}
                                                onChange={(content, delta, source) =>
                                                    handleChangeContact(source, content)
                                                }
                                                modules={quillModules}
                                                formats={quillFormats}
                                                name="contactInformation"
                                            />
                                        </Colxx>
                                    }
                                </Row>
                            </div>
                        </TabPane>
                    </TabContent>
                    <TabContent activeTab={activeTab}>
                        <TabPane tabId="propertybot">
                            <div className="pt-2 pr-4 pl-4 pb-2">
                                <Row>
                                    <Colxx md={12} className="mt-2">
                                        <div className="d-flex w-100">
                                            <Label>Enable</Label>
                                            <Switch
                                                className="agentswitch custom-switch-primary custom-switch-small ml-2"
                                                checked={checkedPropertyBot}
                                                onChange={(primary) => handleSwitchPropertyBotChange(primary)}
                                            />
                                        </div>
                                    </Colxx>
                                    <Colxx md={12} className="mt-2">
                                        <Label>Title</Label>
                                        <div className="mb-2">
                                            <Input
                                                type="text"
                                                name="title"
                                                placeholder="Title"
                                                value={botProperty.propertyDetails.title}
                                                onChange={(e) => handleChangePropertyBot(e)}
                                            ></Input>
                                        </div>
                                    </Colxx>
                                    <Colxx md={12} className="mt-2">
                                        <Label>Sub Title</Label>
                                        <div className="mb-2">
                                            <Input
                                                type="text"
                                                name="subTitle"
                                                placeholder="Sub Title"
                                                value={botProperty.propertyDetails.subTitle}
                                                onChange={(e) => handleChangePropertyBot(e)}
                                            ></Input>
                                        </div>
                                    </Colxx>
                                    {botProperty.disabled === true &&
                                        <Colxx md={12} className="mt-3">
                                            <Label>Contact Information</Label>
                                            <Input
                                                type="textarea"
                                                value={botProperty.propertyDetails.contactInformation}
                                                onChange={(e) => handleChangePropertyBot(e)}
                                                name="contactInformation"
                                                style={{ height: "100px" }}
                                            />
                                        </Colxx>
                                    }
                                </Row>
                            </div>
                        </TabPane>
                    </TabContent>
                    <TabContent activeTab={activeTab} >
                        <TabPane tabId="property">
                            <div className="pt-2 pr-4 pl-4 pb-2">
                                <Row>
                                    <Colxx md={12} className="mt-2">
                                        <div className="d-flex w-100">
                                            <Label>Choose Property</Label>
                                            <Switch
                                                className="agentswitch custom-switch-primary custom-switch-small ml-2"
                                                checked={checkedProperty}
                                                onChange={(primary) => handleSwitchPropertyChange(primary)}
                                            />
                                        </div>
                                    </Colxx>
                                    <Colxx md={12} className="mt-2">
                                        <Label>Title</Label>
                                        <div className="mb-2">
                                            <Input
                                                type="text"
                                                name="title"
                                                placeholder="Title"
                                                value={propertyDetails.title}
                                                onChange={handleChangeProperty}
                                            ></Input>
                                        </div>
                                    </Colxx>
                                    <Colxx md={12} className="mt-2">
                                        <Label>Sub Title</Label>
                                        <div className="mb-2">
                                            <Input
                                                type="text"
                                                name="subTitle"
                                                placeholder="Sub Title"
                                                value={propertyDetails.subTitle}
                                                onChange={handleChangeProperty}
                                            ></Input>
                                        </div>
                                    </Colxx>
                                    <Colxx md={12} className="mt-2">
                                        <Label>Avatar Image</Label><br />
                                        <CardImg
                                            style={{ maxWidth: "90px !important" }}
                                            top
                                            src={botInputData.avatarImage === null || botInputData.avatarImage === "" ?
                                                "https://via.placeholder.com/250x150" :
                                                botInputData.avatarImage}
                                            alt="Card image cap"
                                            className="img-thumbnail border-0 rounded-circle list-thumbnail mt-2 ml-2 image-width"
                                        />
                                        <div className="mb-1">
                                            <Button
                                                color="success"
                                                size="xs"
                                                className="mt-1"
                                                onClick={togglegallery}
                                            >
                                                Browse Avatars
                                            </Button>
                                        </div>
                                    </Colxx>
                                    <Colxx md={12} className="mt-2">
                                        <Label>Welcome Message</Label>
                                        <ReactQuill
                                            theme="snow"
                                            value={propertyDetails.contactInformation}
                                            onChange={(content, delta, source) =>
                                                handleChangeWelcomeMessage(source, content)
                                            }
                                            modules={quillModules}
                                            formats={quillFormats}
                                            name="contactInformation"
                                        />
                                    </Colxx>
                                    <Colxx md={12} className="mt-2">
                                        <Label>Buttons</Label>
                                        <Separator className="mb-2" />
                                        {inputFields.map((nudge, index) => (
                                            <Row>
                                                <Colxx sm={4} className="mb-3">
                                                    <Label>Text</Label>
                                                    <Input
                                                        type="text"
                                                        name="text"
                                                        value={nudge.text}
                                                        onChange={event => handleInputChange(index, event)}
                                                    />
                                                </Colxx>
                                                <Colxx sm={3} className="mb-3">
                                                    <Label>Option</Label>
                                                    <Input
                                                        type="select"
                                                        name="option"
                                                        value={nudge.option}
                                                        onChange={event => handleInputChange(index, event)}
                                                    >
                                                        <option value={"None"}>Select</option>
                                                        <option value={"Location"}>Location</option>
                                                        <option value={"Help"}>Help</option>
                                                        <option value={"Recommender"}>Recommender</option>
                                                    </Input>
                                                </Colxx>
                                                {nudge.option === "Recommender" &&
                                                    <Colxx sm={4} className="mb-3">
                                                        <Label>Recommender</Label>
                                                        <Input
                                                            type="select"
                                                            name="value"
                                                            value={nudge.value}
                                                            onChange={event => handleInputChange(index, event)}
                                                        >
                                                            <option value={""}>Select</option>
                                                            {recommenderData.length > 0 && recommenderData.map((rec) => (
                                                                <option value={rec.id}>{rec.name}</option>
                                                            ))}
                                                        </Input>
                                                    </Colxx>
                                                }
                                                <Colxx sm={1} className="mb-3">
                                                    <Label>Remove</Label>
                                                    <div>
                                                        <Button
                                                            onClick={() => handleRemoveFields(index)}
                                                            color="secondary"
                                                            size="xs"
                                                            outline
                                                            style={{ margin: '6px' }}
                                                        >
                                                            -
                                                        </Button>
                                                    </div>
                                                </Colxx>
                                            </Row>))}
                                        <Button
                                            onClick={handleAddFields}
                                            color="primary"
                                            size="xs"
                                            outline
                                            style={{ margin: '6px' }}
                                        >
                                            + Add Button
                                        </Button>
                                    </Colxx>
                                </Row>
                            </div>
                        </TabPane>
                    </TabContent>
                    <Row>
                        <Colxx md={12} className="mt-4 text-center">
                            <Button
                                color="primary"
                                size="xs"
                                className="mt-1"
                                onClick={() => handleSave()}
                            >
                                Save
                            </Button>
                        </Colxx>
                    </Row>
                </CardBody>
            </Card>
            {ImageGalleryButton()}
        </Fragment>
    );
}